<template>
  <div>
    <!-- VegaWallet 帳號 + 密碼 -->
    <div class="colu colu-12" :class="isPC ? 'fun-withdraw-vega' : ''">
      <label class="colu-12 for-label">{{ $t('Bao.deposit_account') }}</label>
      <div :class="isPC ? 'wallet-amount-frame' : ''">
        <input
          :value="withdrawalInfo.uid"
          class="for-input inpType"
          type="text"
          :placeholder="$t('Bao.deposit_account')"
          autocomplete="off"
          @input="onUidInput($event.target.value)"
          @blur="$emit('check-account-errors')"
        >
      </div>
      <div
        v-for="error in accountErrors"
        :key="error"
        class="input-feedback text-align-R"
      >
        {{ error }}
      </div>
    </div>

    <div class="colu colu-12" :class="isPC ? 'fun-withdraw-vega' : ''">
      <label class="colu-12 for-label">{{ $t('Bao.deposit_password') }}</label>
      <div :class="isPC ? 'wallet-amount-frame' : ''">
        <input
          v-validate="'required'"
          :value="withdrawalInfo.password"
          class="for-input inpType"
          type="password"
          name="vega-password"
          :placeholder="$t('Bao.deposit_password')"
          autocomplete="off"
          @input="onPasswordInput($event.target.value)"
        >
      </div>
      <div v-if="errors.has('vega-password')" class="input-feedback text-align-R">
        {{ $t('Bao.deposit_password_error') }}
      </div>
    </div>
  </div>
</template>

<script>
import { detectMob } from '@/utils/tool'

export default {
  name: 'PaymentMethodFields',
  inject: {
    errors: { default: () => ({ has: () => false }) }
  },
  props: {
    /** withdrawal_info：{ uid, password } */
    withdrawalInfo: {
      type: Object,
      default: () => ({})
    },
    accountErrors: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {

    }
  },
  computed: {
    isPC() {
      return !detectMob()
    }
  },
  methods: {
    onUidInput(value) {
      this.$emit('update:withdrawal-info', { ...this.withdrawalInfo, uid: value })
      this.$emit('check-account-errors')
    },
    onPasswordInput(value) {
      this.$emit('update:withdrawal-info', { ...this.withdrawalInfo, password: value })
    }
  }
}
</script>
